export function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-surface-page flex items-center justify-center" role="status">
      <span className="sr-only">Loading</span>
      <svg className="w-8 h-8 text-accent animate-spin" fill="none" viewBox="0 0 24 24" aria-hidden>
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
    </div>
  );
}
